import { ReportType } from "../../../../../api/types/svTypes.ts";

export const chartRelatedReportTypes = [
  ReportType.AreaChart,
  ReportType.BarChart,
  ReportType.DoughnutChart,
  ReportType.LineChart,
  ReportType.PieChart,
  ReportType.TreeMapChart,
];
